import AppealsTestSimulationSection from '../../../sections/AdminDashboard/Configuration/AppealsTestSimulation';

const AppealsTestSimulation = () => <AppealsTestSimulationSection />;

export default AppealsTestSimulation;
